import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'

import './index.css'
import App from './App'
import { store } from './store'
import * as serviceWorker from './serviceWorker'
import {
  isValidOrganization,
  handleInvalidOrganization,
} from './settings/configs'
import { theme } from './settings/theme'

if (!isValidOrganization) handleInvalidOrganization()

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
